var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#f6f7f9"}},[_c('a-row',{staticClass:"nav",attrs:{"type":"flex","justify":"space-between","align":"middle"}},[_c('a-col',[_c('span',{class:{
          navButton: true,
          activedButton: _vm.activedHead === 'instances' ? true : false,
        },on:{"click":function($event){return _vm.changePage('instances')}}},[_vm._v("模型")]),_c('span',{class:{
          navButton: true,
          activedButton: _vm.activedHead === 'algorithms' ? true : false,
        },on:{"click":function($event){return _vm.changePage('algorithms')}}},[_vm._v("机器学习算法")]),_c('span',{class:{
          navButton: true,
          activedButton: _vm.activedHead === 'myInstances' ? true : false,
        },on:{"click":function($event){return _vm.changePage('myInstances')}}},[_vm._v("我的模型")]),_c('span',{class:{
          navButton: true,
          activedButton: _vm.activedHead === 'myCalc' ? true : false,
        },on:{"click":function($event){return _vm.changePage('myCalc')}}},[_vm._v("计算记录")]),_c('span',{class:{
          navButton: true,
          activedButton: _vm.activedHead === 'help' ? true : false,
        },on:{"click":function($event){return _vm.changePage('help/index')}}},[_vm._v("文档")])]),_c('a-col',{class:{
        navButton: true,
      },on:{"click":_vm.logout}},[_vm._v("登出 ")])],1),_c('a-row',{staticClass:"navHeight"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }